<template>
  <!-- :fill-height="!$vuetify.breakpoint.xsOnly" -->
 <v-container fluid fill-height >
   <v-row justify="center" align="center">
      <v-col cols="12" md="8">
        <!-- <v-card elevation="0"> -->
          <!-- <v-card-title>Checkout</v-card-title> -->
          <v-card-text justify="center" align="center">
            <div id="payment-status">
        <div id="status-icon" v-if="session?session.status =='complete':''"><v-icon size="80" color="green">mdi-checkbox-marked-circle</v-icon></div>
        <div id="status-icon" v-if="session?session.status =='open':''"><v-icon size="80" color="red">mdi-close-circle</v-icon></div>
        <h2 id="status-text"> {{session?session.status =='complete'?'Payment succeeded':session.status =='open'?'Payment failed':'':'' }} </h2>
        <div id="details-table">
          <table>
            <tbody>
              
               <tr>
                <td class="TableLabel">Email :</td>
                <td id="intent-status" class="TableContent">{{ customer_email }}</td>
              </tr>
              <tr>
                <td class="TableLabel">Description :</td>
                <td id="intent-status" class="TableContent">{{ session?session.line_items.data[0].description :"" }}</td>
              </tr>
               <tr>
                <td class="TableLabel">Amount Total :</td>
                <td id="intent-status" class="TableContent">{{ session? `${session.line_items.data[0].amount_total/100} ${session.line_items.data[0].currency}` :"" }}</td>
              </tr>
              <tr>
                <td class="TableLabel">Status :</td>
                <td id="intent-status" class="TableContent">{{ session?session.status :"" }}</td>
              </tr>
               <!-- <tr>
                <td class="TableLabel">Payment Intent ID :</td>
                <td id="intent-id" class="TableContent">{{ session?session.payment_intent :"" }}</td>
              </tr> -->
              <tr>
                <td class="TableLabel">Payment Status :</td>
                <td id="session-status" class="TableContent">{{ session?session.payment_status :"" }}</td>
              </tr>
            </tbody>
          </table>
          
        </div>
               <v-row justify="center" align="center" class="mt-n4">
         <v-col cols="12" md="6">
          <!--    @click="onClickMenu('/contact')" -->
                  <v-btn
                   @click="onClickOpentabpdf('download')"
               outlined
                v-bind:style="{ fontSize:'14px',fontWeight:'600 !important',color:'#215295' }"
                height="35"
               
              >
             Download Invoice
              </v-btn>
         </v-col>
            <v-col cols="12" md="6">
                    <v-btn
                 @click="onClickOpentabpdf('details')"
                v-bind:style="{ fontSize:'14px',fontWeight:'600 !important',backgroundColor:'#215295',color:'#ffffff' }"
                height="35"
              >
               View Invoice Details
              </v-btn>
         </v-col>
       </v-row>

        <v-row justify="center" align="center"  class="mt-n4">
         <v-col cols="12" md="12">
                  <v-btn
                    @click="onClickMenu('/listroom')"
      
                v-bind:style="{ fontSize:'14px',fontWeight:'600 !important',color:'#000000' }"
               
               
              >
              Back to Home
              </v-btn>
         </v-col>

       </v-row>
        <!-- <a href="#" id="view-details" rel="noopener noreferrer" target="_blank">View details
          <svg width="15" height="14" viewBox="0 0 15 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M3.125 3.49998C2.64175 3.49998 2.25 3.89173 2.25 4.37498V11.375C2.25 11.8582 2.64175 12.25 3.125 12.25H10.125C10.6082 12.25 11 11.8582 11 11.375V9.62498C11 9.14173 11.3918 8.74998 11.875 8.74998C12.3582 8.74998 12.75 9.14173 12.75 9.62498V11.375C12.75 12.8247 11.5747 14 10.125 14H3.125C1.67525 14 0.5 12.8247 0.5 11.375V4.37498C0.5 2.92524 1.67525 1.74998 3.125 1.74998H4.875C5.35825 1.74998 5.75 2.14173 5.75 2.62498C5.75 3.10823 5.35825 3.49998 4.875 3.49998H3.125Z" fill="#0055DE"/>            <path d="M8.66672 0C8.18347 0 7.79172 0.391751 7.79172 0.875C7.79172 1.35825 8.18347 1.75 8.66672 1.75H11.5126L4.83967 8.42295C4.49796 8.76466 4.49796 9.31868 4.83967 9.66039C5.18138 10.0021 5.7354 10.0021 6.07711 9.66039L12.7501 2.98744V5.83333C12.7501 6.31658 13.1418 6.70833 13.6251 6.70833C14.1083 6.70833 14.5001 6.31658 14.5001 5.83333V0.875C14.5001 0.391751 14.1083 0 13.6251 0H8.66672Z" fill="#0055DE"/></svg>
        </a> -->
        <!-- <a id="retry-button" href="/checkout.html">Test another</a> -->
    </div>
            <!-- <div id="checkout"></div> -->
          </v-card-text>
        <!-- </v-card> -->
      </v-col>

    </v-row>
      <LoadingDialog></LoadingDialog>
</v-container>
</template>

<script>
import api from "@/services/api";
import { server } from "../services/constants.js";
import { feature } from "../services/constants.js";
import LoadingDialog from "@/components/cards/LoadingDialog";

export default {
  name: "Contact",
  data: () => ({
    invoice: null,
    customer_email:"",
    session:null,
    stripe:null,
    showpop: false,
    dateNow: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
      .toISOString()
      .replace("T", " ")
      .substr(0, 16),
    margincardpriceplans: "mx-auto ml-0 mt-0 mr-0 mb-0",
    width: 420,
    width_emp: 600,
    text_fontsize: 30,
    privacy_sta: "false",
    privacyDlg: false,
  }),
  components: {
      LoadingDialog,
    },
   async beforeCreate() {
      this.$store.state.page_reload = false;
    },
    async mounted() {
      this.$store.state.loadMenu = true;
      const userId = localStorage.getItem(server.USER_ID);
       if (userId && !api.isLoggedIn()) {
      this.$router.push("/listroom");
      return;
    }
    if(!this.$route.query.session_id){
      this.$router.push("/listroom");
      return;
    }
    
    try {
      // โหลด stripe แค่ครั้งเดียว
      // this.stripe = await getStripe();
    } catch (err) {
      console.error("Stripe init error:", err);
    }
    await this.createsession_statusstripepayment();
    this.$store.state.loadMenu = false;
    },
    computed: {
  buttonsmall() {
     if(this.$vuetify.breakpoint.name === "xs"){
       return true;
     }
      },
    widthbutton() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return "75%";
        case "sm":
          return "76%";
        case "md":
          return "60%";
        case "lg":
          return "40%";
        case "xl":
          return "40%";
      }
    },
    widthheightimage(){
 switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return "300";
        case "sm":
          return "400";
        case "md":
          return "400";
        case "lg":
          return "400";
        case "xl":
          return "400";
      }
      },
    },
    methods: {
      async createsession_statusstripepayment(){
    const result =  await api.session_statusstripepayment({session_id:this.$route.query.session_id});
    // console.log(result.data)
    if(result.data.session){
    this.session = result.data.session;
    this.customer_email = result.data.customer_email;
    // this.invoice = result.data.invoice;
    }
      },
     async onClickOpentabpdf(mode){
      let win;
      if(mode == "download"){
 win = window.open(
        `${this.session.invoice.invoice_pdf}`,
        "_blank"
      );
      }else if(mode == "details"){
 win =window.open(
        `${this.session.invoice.hosted_invoice_url}`,
        "_blank"
      );
      }else{

      }
       if (win && !win.closed) {
        // console.log("✅ New tab opened successfully");
      } else {
        // console.warn("❌ Failed to open new tab (possibly blocked by popup blocker)");
      }

      },
      onClickMenu(link) {
      // console.log(link);
      this.$router.push(link).catch((err) => {});
    },
    },
};
</script>


<style scoped>

@media only screen and (max-width: 320px)  {
  .v-application {
    margin-top:-50px;
  }
  
}
  @media only screen and (min-width: 320px) and (max-width: 599px)  {
  /* .mainpage-container {
    margin-top:-150px;
  } */
  .v-application {
    margin-top:-50px;
    /* height: 110% !important; */
  }
  
}
@media only screen and (min-width: 600px) and (max-width: 960px)  {
  .homefeature{
    height:80vh !important;
  }
}

@media (min-width: 960px) {
  .mainpage-container {
    margin-top: 3rem
  }
}

.v-main {
    overflow:auto;
    /* max-width: 100%;
    height: 100%;
    width: 100%;
    background-image: linear-gradient(to right top, #cbe9f8, #dcedfc, #ebf2fd, #f7f8fe, #ffffff) !important; */
}

.homefeature{
  background-image: linear-gradient(to right top, #cbe9f8, #dcedfc, #ebf2fd, #f7f8fe, #ffffff) !important;
    /* height: 60vh; */
    width: 100%;
}
.homepricing{
  background-image: linear-gradient(to bottom, #95bef2, #99c0f2, #9dc2f2, #a0c4f2, #a4c6f2) !important;
    /* height: 50vh; */
    width: 100%;
    align-content: center;
}
.homegettotouch{
  background-color: #19396A !important;
    /* height: 50vh; */
    width: 100%;
    align-content: center;
}

.homepricing_paragraph{
  transform: translateY(20px);
  opacity: 0;
  transition: 2s ease;
}
.homepricing_paragraph--visible{
  transform: translateY(0);
  opacity: 1;
}

ul, #myUL {
  list-style-type: none;
}

#myUL {
  margin: 0;
  padding: 0;
}

.caret {
  font-size:19.5px;
  font-weight:300;
  cursor: pointer;
  -webkit-user-select: none; /* Safari 3.1+ */
  -moz-user-select: none; /* Firefox 2+ */
  -ms-user-select: none; /* IE 10+ */
  user-select: none;
}

.caret::before {
  content: "\25B6";
  color: black;
  display: inline-block;
  margin-right: 6px;
}

.caret-down::before {
  -ms-transform: rotate(90deg); 
  -webkit-transform: rotate(90deg);
  transform: rotate(90deg);  
}

.nested {
  padding-top: 10px;
  padding-bottom: 10px;
  font-size:19.5px;
  font-weight:300;
  display: none;
}

.active {
  display: block;
}
 .row {
    display: flex;
    justify-content: space-between;
    align-items: flex-start; /* หรือ center ตามความต้องการ */
  }

  .row ul {
    list-style: none;
    margin: 0;
    padding: 0;
  }
  .wrap-text {
  -webkit-line-clamp: unset !important;
}

 .transparent-background {
      background-color: transparent !important;
      box-shadow: none !important;
    }
    sup{
          /* top: -1.5em !important; */
          margin-right: 10px;
    }
    * {
    box-sizing: border-box;
  }

body {
  font-family: -apple-system, BlinkMacSystemFont, sans-serif;
  font-size: 16px;
  -webkit-font-smoothing: antialiased;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-content: center;
  height: 100vh;
  width: 100vw;
}

form {
  width: 35vw;
  min-width: 500px;
  align-self: center;
  box-shadow: 0px 0px 0px 0.5px rgba(50, 50, 93, 0.1),
    0px 2px 5px 0px rgba(50, 50, 93, 0.1), 0px 1px 1.5px 0px rgba(0, 0, 0, 0.07);
  border-radius: 7px;
  padding: 40px;
  margin-top: auto;
  margin-bottom: auto;
  overflow: scroll;
}

/* Payment status page */
#payment-status {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    row-gap: 30px;
    width: 30vw;
    min-width: 500px;
    min-height: 380px;
    align-self: center;
    box-shadow: 0px 0px 0px 0.5px rgba(50, 50, 93, 0.1),
      0px 2px 5px 0px rgba(50, 50, 93, 0.1), 0px 1px 1.5px 0px rgba(0, 0, 0, 0.07);
    border-radius: 7px;
    padding: 40px;
    opacity: 0;
    animation: fadeInAnimation 1s ease forwards;
  }

  #status-icon {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 40px;
    width: 40px;
    border-radius: 50%;
  }

  h2 {
    margin: 0;
    color: #30313D;
    text-align: center;
  }

  a {
    text-decoration: none;
    font-size: 16px;
    font-weight: 600;
    font-family: Arial, sans-serif;
    display: block;
  }
  a:hover {
    filter: contrast(120%);
  }

  #details-table {
    overflow-x: auto;
    width: 100%;
  }

  table {
    width: 100%;
    font-size: 14px;
    border-collapse: collapse;
  }
  table tbody tr:first-child td {
    border-top: 1px solid #E6E6E6; /* Top border */
    padding-top: 10px;
  }
  table tbody tr:last-child td {
    border-bottom: 1px solid #E6E6E6; /* Bottom border */
  }
  td {
    padding-bottom: 10px;
  }

  .TableContent {
    text-align: right;
    color: #6D6E78;
  }

  .TableLabel {
    font-weight: 600;
    color: #30313D;
  }

  #view-details {
    color: #0055DE;
  }

  #retry-button {
    text-align: center;
    background: #0055DE;
    color: #ffffff;
    border-radius: 4px;
    border: 0;
    padding: 12px 16px;
    transition: all 0.2s ease;
    box-shadow: 0px 4px 5.5px 0px rgba(0, 0, 0, 0.07);
    width: 100%;
  }

  @-webkit-keyframes loading {
    0% {
      -webkit-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    100% {
      -webkit-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }
  @keyframes loading {
    0% {
      -webkit-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    100% {
      -webkit-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }
  @keyframes fadeInAnimation {
    to {
        opacity: 1;
    }
  }

  @media only screen and (max-width: 600px) {
    form, #payment-status{
      width: 80vw;
      min-width: initial;
    }
  }
</style>
